import { DonationStatusTypeEnum } from '../enum/donation-status.enum';

export class DonationStatusModel {
  pledging_status: DonationStatusTypeEnum = null;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
